import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { IncidenceTaskDocumentsQueryData } from 'modules/bookkeepers/hooks/useGetIncidenceTaskDocuments'
import documentDownloadUrl from 'modules/documents/lib/documentDownloadUrl'

import FileCard from '../FileCard'

interface Props {
  taskDocuments: IncidenceTaskDocumentsQueryData
  bookkeeperView: boolean
}

const TaskDocuments = ({ taskDocuments, bookkeeperView }: Props) => {
  return (
    <Box gap="s8">
      <Text.Normal size="200" color="grey800">
        {i18n.t('bookkeepers.incidence.details.task_documents')}
      </Text.Normal>

      {taskDocuments.map((document) => {
        const downloadUrl = documentDownloadUrl(document.documentId, bookkeeperView)
        return (
          <FileCard
            downloadUrl={downloadUrl}
            filename={document.documentFilename}
            key={document.id}
          />
        )
      })}
    </Box>
  )
}

export default TaskDocuments
